import { render, staticRenderFns } from "./TikTokPostTable.vue?vue&type=template&id=1916d30d&scoped=true"
import script from "./TikTokPostTable.vue?vue&type=script&lang=ts"
export * from "./TikTokPostTable.vue?vue&type=script&lang=ts"
import style0 from "./TikTokPostTable.vue?vue&type=style&index=0&id=1916d30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916d30d",
  null
  
)

export default component.exports